import { CSSProperties } from 'react'

import { combineClassnames } from 'app/common/presentation'

import styles from './Tooltip.module.scss'

export interface TooltipProps<V> {
  className?: string
  formatValue: (value: V, index: number) => JSX.Element | string
  label?: string
  style?: CSSProperties
  values: V[]
}

const Tooltip = <V,>({ className, formatValue, label, style, values }: TooltipProps<V>) => (
  <div className={combineClassnames(styles.tooltip, className)} style={style}>
    {label && <div className={styles.label}>{label}</div>}
    <div>
      {values.map((value, index) => (
        <div className={styles.value} key={index}>
          {formatValue(value, index)}
        </div>
      ))}
    </div>
  </div>
)

export default Tooltip
